import { render, staticRenderFns } from "./LegendDetails.vue?vue&type=template&id=ec5b4e88&"
import script from "./LegendDetails.vue?vue&type=script&lang=ts&"
export * from "./LegendDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports